import * as falso from '@ngneat/falso';

// temporary file, after fixes on BE it shold be removed and replaced with methods from src/__mocks__/folder.ts
falso.seed('folders-mock');
const idFactory = falso.incrementalNumber();


export const createMockAdminAssessmentFolder = (): AdminAssessmentFolder => ({
  id: idFactory().toString(),
  name: falso.randCompanyName(),
});

export const createMockLongAdminAssessmentFolder = (): AdminAssessmentFolder => ({
  id: idFactory().toString(),
  // eslint-disable-next-line max-len
  name: 'Lorem ipsum dolor sit amet consectetur. Blandit nunc nisi integer placerat dignissim facilisi quis. Sagittis interdum sem orci libero auctor augue. Tortor malesuada congue lacinia etiam amet integer ut magna. Urna est arcu scelerisque netus viverra libero.',
});

export const createMockAdminAssessmentFolders = (length?: number): AdminAssessmentFolder[] => (
  Array.from({ length: length || falso.randNumber({ min: 0, max: 100 }) }, () => createMockAdminAssessmentFolder())
);

export const createMockLongAdminAssessmentFolders = (length?: number): AdminAssessmentFolder[] => (
  Array.from({ length: length || falso.randNumber({ min: 0, max: 100 }) }, () => createMockLongAdminAssessmentFolder())
);

export const createMockAdminAssessmentSubFolder = (): AdminAssessmentSubFolder => ({
  id: idFactory().toString(),
  name: falso.randCompanyName(),
});

export const createMockAdminAssessmentSubFolders = (length?: number): AdminAssessmentSubFolder[] => (
  Array.from({ length: length || falso.randNumber({ min: 0, max: 100 }) }, () => createMockAdminAssessmentSubFolder())
);

export const createMockAdminAssessmentWithSubfolder = (): AdminAssessmentFolder => ({
  id: idFactory().toString(),
  name: falso.randCompanyName(),
  subFolders: createMockAdminAssessmentSubFolders(falso.randNumber({ min: 0, max: 3 })),
});

export const createMockAdminAssessmentFoldersWithSubfolders = (length?: number): AdminAssessmentFolder[] => (
  Array.from({ length: length || falso.randNumber({ min: 0, max: 100 }) }, () => createMockAdminAssessmentWithSubfolder())
);

export const createMockLongAdminAssessmentFolderWithSubfolders = (): AdminAssessmentFolder => ({
  id: idFactory().toString(),
  // eslint-disable-next-line max-len
  name: 'Lorem ipsum dolor sit amet consectetur. Blandit nunc nisi integer placerat dignissim facilisi quis. Sagittis interdum sem orci libero auctor augue. Tortor malesuada congue lacinia etiam amet integer ut magna. Urna est arcu scelerisque netus viverra libero.',
  subFolders: createMockAdminAssessmentSubFolders(falso.randNumber({ min: 0, max: 3 })),
});

export const createMockLongAdminAssessmentFoldersWithSubfolders = (length?: number): AdminAssessmentFolder[] => (
  Array.from({
    length: length || falso.randNumber({ min: 0, max: 100 }),
  }, () => createMockLongAdminAssessmentFolderWithSubfolders())
);
